// extracted by mini-css-extract-plugin
export default {"checked":"switch_checked__JQDXA"};